import { useFormContext, Controller } from "react-hook-form";
import { CreditCardField, NumberFormat, TextField } from "vino/core/forms";

const PaymentMethodCard = () => {
	const { control, formState } = useFormContext();
	const { errors } = formState;
	return (
		<div className="flex flex-col w-full">
			<div className="mb-16">
				<Controller
					name="card.number"
					control={control}
					render={({ field }) => (
						<CreditCardField
							{...field}
							label="Card number"
							error={!!errors.card?.number}
							helperText={errors?.card?.number?.message}
							variant="outlined"
							required
							fullWidth
						/>
					)}
				/>
			</div>
			<div className="mb-16">
				<TextField
					name="card.nameOnCard"
					className="mb-16"
					label="Name on Card"
					variant="outlined"
					required
					fullWidth
					placeholder="Name on Card"
				/>
			</div>

			<div className="flex mb-16">
				<TextField
					name="card.expMonth"
					label="Expiry Month"
					variant="outlined"
					required
					placeholder="MM"
					inputProps={{
						format: "##",
					}}
					InputProps={{
						inputComponent: NumberFormat,
					}}
				/>

				<div className="mx-28">
					<TextField
						name="card.expYear"
						label="Expiry Year"
						placeholder="YY"
						variant="outlined"
						required
						inputProps={{
							format: "##",
						}}
						InputProps={{
							inputComponent: NumberFormat,
						}}
					/>
				</div>

				<TextField
					name="card.cvv"
					label="CVV"
					className="w-68"
					variant="outlined"
					required
					inputProps={{
						format: "####",
					}}
					InputProps={{
						inputComponent: NumberFormat,
					}}
				/>
			</div>
		</div>
	);
};

export default PaymentMethodCard;
